import React from "react";
import Logo from "./Logo";

const SOCIALS = [
  { name: "Instagram", href: "https://www.instagram.com/bhyyve/" },
  { name: "X", href: "https://x.com/bhyyve" },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61575853774007" },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/bhyyve/" },
  { name: "Website", href: "https://www.bhyyve.com/" },
];

export default function Footer() {
  return (
    <footer className="py-12 px-6 bg-bhyyve-bg border-t border-bhyyve-border" data-testid="founding-footer">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col items-center gap-6">
          <Logo />
          <p className="text-sm text-bhyyve-muted">Engineered for trust.</p>
          <nav className="flex flex-wrap justify-center gap-6">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-bhyyve-muted hover:text-bhyyve-honeyDeep transition-colors"
                data-testid={`footer-social-${s.name.toLowerCase()}`}
              >
                {s.name}
              </a>
            ))}
          </nav>
          <p className="text-xs text-bhyyve-muted/60 mt-4">
            &copy; {new Date().getFullYear()} bHyyve Technologies Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
